import React from 'react';
import './SkillsChart.css';
import { 
  SiC, SiCplusplus, SiPython, SiJavascript, 
  SiHtml5, SiCss3, SiReact, SiNodedotjs, SiExpress,
  SiGit, SiGithub, SiPostman, SiDocker, SiGooglecloud,
  SiOracle, SiPostgresql, SiMysql, SiMongodb, SiFirebase
} from 'react-icons/si';
import { FaJava } from 'react-icons/fa';
import { VscVscode } from "react-icons/vsc";

const SkillsChart = () => {
  const skillCategories = [
    {
      category: 'Programming Languages',
      skills: [
        { name: 'C', icon: <SiC />, color: '#A8B9CC' },
        { name: 'C++', icon: <SiCplusplus />, color: '#00599C' },
        { name: 'Python', icon: <SiPython />, color: '#3776AB' },
        { name: 'JavaScript', icon: <SiJavascript />, color: '#F7DF1E' },
        { name: 'Java', icon: <FaJava />, color: '#007396' }
      ]
    },
    {
      category: 'Web Technologies',
      skills: [
        { name: 'HTML', icon: <SiHtml5 />, color: '#E34F26' },
        { name: 'CSS', icon: <SiCss3 />, color: '#1572B6' },
        { name: 'React', icon: <SiReact />, color: '#61DAFB' },
        { name: 'Node.js', icon: <SiNodedotjs />, color: '#339933' },
        { name: 'Express', icon: <SiExpress />, color: '#000000' }
      ]
    },
    {
      category: 'Tools & Platforms',
      skills: [
        { name: 'VS Code', icon: <VscVscode />, color: '#007ACC' },
        { name: 'Git', icon: <SiGit />, color: '#F05032' },
        { name: 'GitHub', icon: <SiGithub />, color: '#181717' },
        { name: 'Postman', icon: <SiPostman />, color: '#FF6C37' },
        { name: 'Docker', icon: <SiDocker />, color: '#2496ED' },
        { name: 'Google Cloud', icon: <SiGooglecloud />, color: '#4285F4' }
      ]
    },
    {
      category: 'Databases',
      skills: [
        { name: 'Oracle SQL', icon: <SiOracle />, color: '#F80000' },
        { name: 'PostgreSQL', icon: <SiPostgresql />, color: '#4169E1' },
        { name: 'MySQL', icon: <SiMysql />, color: '#4479A1' },
        { name: 'MongoDB', icon: <SiMongodb />, color: '#47A248' },
        { name: 'Firebase', icon: <SiFirebase />, color: '#FFCA28' }
      ]
    }
  ];

  return (
    <div className="skills-chart-container">
      {skillCategories.map((category, index) => (
        <div key={index} className="skill-category">
          <h3 className="category-title">{category.category}</h3>
          <div className="skills-grid">
            {category.skills.map((skill, skillIndex) => (
              <div 
                key={skillIndex} 
                className="skill-item"
                style={{ '--skill-color': skill.color }}
              >
                <div className="skill-icon">
                  {skill.icon}
                </div>
                <span className="skill-name">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SkillsChart;
